/** 主题色 */
export const themeColor: any = {
  'theme-base': {
    // 默认主题--金色
    'theme-color': '#e6a23c',
    'theme-tips-color': '#98121b',
    'theme-but-color': '#b11f26',
    'edit-color': '#077ffb',
    'up-color': '#cb2634',
    'down-color': '#009a29',
    'audit-color': '#e45158',
    'link-color': '#077ffb',
    'border-color': '#dcdcdc',
    'bg-color': '#eeeeee',
    'shallow-bg-color': '#fff7eb',
    'chose-color': '#fff4f4',
    'content-bg-color': '#fff',
    'title-color': 'rgba(0, 0, 0, 0.85)',
    'text-color': 'rgba(0, 0, 0, 0.8)',
    'tip-color': 'rgba(0, 0, 0, 0.4)',
    'nav-color': '#131414',
    'input-color': '#8a8a8a',

    'el-color-primary': '#077ffb',
    'el-color-success': '#e6a23c'
  },
  'theme-blue': {
    // 新湖主题--蓝色
    'theme-color': '#006869',
    'theme-tips-color': 'blue',
    'theme-but-color': 'blue',
    'edit-color': '#006869',
    'up-color': 'blue',
    'down-color': 'blue',
    'audit-color': 'blue',
    'link-color': 'blue',
    'border-color': 'blue',
    'bg-color': '#cbdce9',
    'shallow-bg-color': '#cce1e1',
    'chose-color': '#d9f3fc',
    'content-bg-color': '#fff',
    'title-color': '#006869',
    'text-color': '#006869',
    'tip-color': 'rgba(0, 0, 0, 0.4)',
    'nav-color': '#006869',
    'input-color': '#006869',

    'el-color-primary': '#006869',
    'el-color-success': '#006869'
  },
  'theme-red': {
    // 新湖主题--红色
    'theme-color': '#407cac',
    'theme-tips-color': 'blue',
    'theme-but-color': 'blue',
    'edit-color': '#407cac',
    'up-color': 'blue',
    'down-color': 'blue',
    'audit-color': 'blue',
    'link-color': 'blue',
    'border-color': 'blue',
    'bg-color': 'rgba(178, 185, 213,0.3)',
    'shallow-bg-color': '#cce1e1',
    'chose-color': '#d9f3fc',
    'content-bg-color': '#fff',
    'title-color': '#407cac',
    'text-color': '#407cac',
    'tip-color': 'rgba(0, 0, 0, 0.4)',
    'nav-color': '#407cac',
    'input-color': '#407cac',

    'el-color-primary': '#407cac',
    'el-color-success': '#407cac'
  }
}
